import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import { createGroupObjFromGroupInfoForm, getBaseGroupData } from '../../utils/ClubGroupsUtils';

import NavLinks from '../../../NavLinks';

import useClubGroupsData from '../../../../../state/clubGroups/UseClubGroupsData';

import validate from '@usas/ui-web/components/forms/groups/GroupInfoFormValidation';

import useGroupCategoryData from '@usas/ui-web/state/groupCategory/UseGroupCategoryData';
import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';

import useForm from '@usas/ui-web/utils/UseForm';
import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

const INITIAL_STATE = {
  pageErrorMessage: ''
};

const INITIAL_FORM_STATE = {
  orgUnitId: '',
  groupTypeId: DEFAULT_ID,
  groupTypeName: '',
  groupCategories: [],
  groupName: '',
  groupCode: '',
  groupDescription: ''
};

const useClubGroupListAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { baseUsasClubState } = useBaseUsasClubData();
  const { groupCategoryState } = useGroupCategoryData();
  const { clubGroupInfoState, postClubGroup } = useClubGroupsData();
  const { formState, errorState, handleSubmit, onFormValueChanged, setFormData
  } = useForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const [state, setState] = useState(INITIAL_STATE);

  const onBackClicked = (event) => {
    try {
      event?.preventDefault();

      navigate(NavLinks.CLUB_GROUPS_GROUP_TYPE);
    } catch (e) {
      setState({
        ...state,
        pageErrorMessage: e.message
      });
    }
  };

  useEffect(() => {
    try {
      if (location.state?.groupTypeId && location.state?.groupTypeName && baseUsasClubState.objData.orgUnitId) {
        if (groupCategoryState.isArrayLoaded === true && baseUsasClubState.isObjLoaded === true) {
          setFormData({
            ...formState,
            groupTypeId: location.state.groupTypeId,
            groupTypeName: location.state.groupTypeName,
            orgUnitId: baseUsasClubState.objData.orgUnitId
          });
        }
      } else {
        navigate(NavLinks.CLUB_GROUPS_GROUP_TYPE);
      }
    } catch (e) {
      setState({
        ...state,
        pageErrorMessage: e.message
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState, groupCategoryState]);

  async function submitFormCallback(formState) {
    try {
      const postClubGroupResult = await postClubGroup(createGroupObjFromGroupInfoForm(getBaseGroupData(), formState));

      if (postClubGroupResult) {
        navigate(NavLinks.CLUB_GROUPS);
      }
    } catch (e) {
      setState({
        ...state,
        pageErrorMessage: e.message
      });
    }
  }

  return {
    isLoading: groupCategoryState.isArrayLoading,
    isSaving: clubGroupInfoState.isObjLoading,
    state,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onBackClicked,
    orgUnitId: baseUsasClubState.objData.orgUnitId || ''
  };
};

export default useClubGroupListAdd;